import Range from '../input/Range';
import { formatCurrency } from '../../services/FormatterService';

export type PriceRangeSelectorProps = {
    availableMaxPrice: number | null;
    availableMinPrice: number | null;
    appliedMaxPrice: number | null;
    appliedMinPrice: number | null;
    onChange: (data: {
        appliedMaxPrice: number | null;
        appliedMinPrice: number | null;
    }) => void;
};

export const PriceRangeSelector = ({
    availableMaxPrice,
    availableMinPrice,
    appliedMaxPrice,
    appliedMinPrice,
    onChange
}: PriceRangeSelectorProps) => {
    if (availableMinPrice === null || availableMaxPrice === null) {
        return null;
    }

    return (
        <Range
            max={availableMaxPrice}
            min={availableMinPrice}
            values={[
                appliedMinPrice ?? availableMinPrice,
                appliedMaxPrice ?? availableMaxPrice
            ]}
            onChange={([minPrice, maxPrice]) =>
                onChange({
                    appliedMaxPrice:
                        maxPrice === availableMaxPrice ? null : maxPrice,
                    appliedMinPrice:
                        minPrice === availableMinPrice ? null : minPrice
                })
            }
            labelFormatter={value => formatCurrency(value, 'EUR', 'es')}
        />
    );
};
